export interface AdhocItem {
  id: number;
  amount: number;
  type: AdhocItemType;
  createdAt?: Date;
  updatedAt?: Date;
  payslipId: number;
}

export enum AdhocItemType {
  OVERTIME = "OVERTIME",
  INCENTIVE = "INCENTIVE",
  MOBILE_ALLOWANCE = "MOBILE_ALLOWANCE",
  OFFDAY = "OFFDAY",
  PUBLIC_HOLIDAY = "PUBLIC_HOLIDAY",
  RETENTION_INCENTIVE = "RETENTION_INCENTIVE",
}

export const AdhocItemTypeLabels: { [key in AdhocItemType]: string } = {
  [AdhocItemType.OVERTIME]: "Overtime",
  [AdhocItemType.INCENTIVE]: "Incentive",
  [AdhocItemType.MOBILE_ALLOWANCE]: "Mobile Allowance",
  [AdhocItemType.OFFDAY]: "Off Day",
  [AdhocItemType.PUBLIC_HOLIDAY]: "Public Holiday",
  [AdhocItemType.RETENTION_INCENTIVE]: "Retention Incentive",
};
